var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0399 0H6.63743C5.41691 0 4.42389 0.993018 4.42389 2.21354V2.48521H2.95988C1.73936 2.48521 0.746338 3.47823 0.746338 4.69875V17.7866C0.746338 19.0071 1.73936 20.0001 2.95988 20.0001H11.3624C12.5829 20.0001 13.5758 19.0071 13.5758 17.7866V17.5149H15.0398C16.2603 17.5149 17.2534 16.5219 17.2534 15.3013V2.21354C17.2535 0.993018 16.2604 0 15.0399 0ZM12.1481 17.7866C12.1481 18.2198 11.7956 18.5723 11.3625 18.5723H2.95988C2.52667 18.5723 2.17418 18.2198 2.17418 17.7866V4.69865C2.17418 4.26545 2.52667 3.91296 2.95988 3.91296H11.3624C11.7956 3.91296 12.148 4.26545 12.148 4.69865V17.7866H12.1481ZM15.8256 15.3013C15.8256 15.7346 15.4731 16.087 15.0399 16.087H13.5759V4.69865C13.5759 3.47813 12.5829 2.48511 11.3625 2.48511H5.85174V2.21344C5.85174 1.78024 6.20422 1.42775 6.63743 1.42775H15.0399C15.4731 1.42775 15.8256 1.78024 15.8256 2.21344V15.3013Z",
    fill: "#F0F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.875acc5b5cc19f56711f4a62082e4f67.svg";
export { ForwardRef as ReactComponent };